import { useAllBook } from 'store/books/selectors';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { filter } from 'lodash';
import { ebookConfigDinamic } from 'utils/lib/ebookHelper';

const useBook = () => {
  const booksAllList = useAllBook();
  const location = useLocation();
  const search = queryString.parse(location.search);
  const activities = useSelector((state) => state.activities);
  const quizzes = useSelector((state) => state.quizzes);
  const questions = useSelector((state) => state.questions);
  const notes = useSelector((state) => state.notes);
  const likes = useSelector((state) => state.likes);
  const interactions = useSelector((state) => state.interactions);
  const classActivities = useSelector((state) => state.classActivities);
  const classQuizzes = useSelector((state) => state.classQuizzes);
  const currentUser = useSelector((state) => state.currentUser);
  const currentClass = useSelector((state) => state.currentClass);
  const servertime = useSelector((state) => state.servertime);
  const timezone = useSelector((state) => state.timezone);
  const classUsers = useSelector((state) => state.classUsers) || [];
  const submissions = useSelector((state) => state.submissions);
  const tipsBook = useSelector((state) => state.tipsBook);
  const worksheetReducer = useSelector((state) => state.worksheetReducer);
  const infoClassUSers = filter(classUsers, (x) => x.role === 'student');

  return {
    activities: activities,
    quizzes: quizzes,
    questions: questions,
    notes: notes,
    likes: likes,
    interactions: interactions,
    classActivities: classActivities,
    classQuizzes: classQuizzes,
    adminClassActivities:
      classActivities?.filter((activity) => activity?.data?.type?.toLowerCase() !== 'custom') || [],
    adminClassQuizzes:
      classQuizzes?.filter((quiz) => quiz?.data?.type?.toLowerCase() !== 'custom') || [],
    currentUser: currentUser,
    currentClass: currentClass,
    isStudent: currentUser?.role === 'student',
    servertime: servertime,
    timezone: timezone,
    quiz: search.quiz,
    activity: search.activity,
    classUsers: classUsers,
    submissions: submissions,
    tipsBook: tipsBook,
    listWorkSheet: worksheetReducer,
    listStudents: () => {
      let listStudents = [];
      if (infoClassUSers?.length === 0) return [];
      for (let u in infoClassUSers) {
        listStudents.push({
          id: infoClassUSers[u].id,
          description: `${infoClassUSers[u].lastName}  ${infoClassUSers[u].firstName} (${infoClassUSers[u].username})`,
        });
      }
      return listStudents;
    },
    booksAllList: booksAllList,
    currentBookData:  search.chapter  ?  ebookConfigDinamic(search.chapter, booksAllList) : {},
    getHiddenBooks: currentClass?.hide_books
      ? currentClass?.hide_books.map((data) => data?.bookId)
      : [],
  };
};

export default useBook;
